export const sssPage = () => `
  <section class="page-content">
    <div class="container">
      <h1 class="page-title">Sıkça Sorulan Sorular</h1>
      <p class="page-subtitle">Sigorta ile ilgili en çok merak edilen konulara burada yanıt bulabilirsiniz.</p>

      <div class="faq-page-list">
        <div class="faq-item">
          <button class="faq-question">
            Araç hasar kaydı sigortayı etkiler mi?
            <span class="faq-icon">+</span>
          </button>
          <div class="faq-answer">
            <p>Evet, araç hasar kayıtları sigorta primlerini etkileyebilir. Hasar kaydı olan araçlarda kasko ve trafik sigortası primleri artabilir. Hasarsızlık indirimi olan araçlarda ise primler daha uygun olur.</p>
          </div>
        </div>

        <div class="faq-item">
          <button class="faq-question">
            Sigorta poliçesinde Muafiyet nedir?
            <span class="faq-icon">+</span>
          </button>
          <div class="faq-answer">
            <p>Muafiyet, hasarın belirli bir tutarının sigortalı tarafından karşılanmasıdır. Örneğin %10 muafiyetli bir poliçede, 10.000 TL'lik hasarın 1.000 TL'sini sigortalı öder, kalan 9.000 TL'yi sigorta şirketi karşılar. Muafiyetli poliçelerde primler genelde daha düşüktür.</p>
          </div>
        </div>

        <div class="faq-item">
          <button class="faq-question">
            İş yeri Sigortası neleri kapsar?
            <span class="faq-icon">+</span>
          </button>
          <div class="faq-answer">
            <p>İş yeri sigortası, işyerinizi yangın, hırsızlık ve doğal afetlere karşı korur. Ayrıca su baskını, cam kırılması, elektronik cihaz hasarı ve üçüncü şahıs sorumlulukları da teminat kapsamına alınabilir.</p>
          </div>
        </div>

        <div class="faq-item">
          <button class="faq-question">
            Dask ve Konut Sigortası ayrımı nedir?
            <span class="faq-icon">+</span>
          </button>
          <div class="faq-answer">
            <p>DASK (Zorunlu Deprem Sigortası) sadece deprem riskini kapsar ve zorunludur. Konut sigortası ise daha geniş kapsamlıdır — yangın, hırsızlık, su baskını, fırtına gibi birçok riski de kapsar. İdeal koruma için ikisinin birlikte yaptırılması önerilir.</p>
          </div>
        </div>

        <div class="faq-item">
          <button class="faq-question">
            Tamamlayıcı Sağlık Sigortasını (TSS) Kimler yaptırabilir?
            <span class="faq-icon">+</span>
          </button>
          <div class="faq-answer">
            <p>TSS'yi SGK (Sosyal Güvenlik Kurumu) kapsamında olan herkes yaptırabilir. SGK'lı çalışanlar, emekliler ve bakmakla yükümlü oldukları kişiler TSS'den faydalanabilir. Özel sağlık sigortasına göre daha uygun fiyatlıdır.</p>
          </div>
        </div>

        <div class="faq-item">
          <button class="faq-question">
            Hangi durumlarda Tamamlayıcı Sağlık Sigortası (TSS) provizyon vermez?
            <span class="faq-icon">+</span>
          </button>
          <div class="faq-answer">
            <p>Önceden var olan hastalıklar ve bekleme süresi içindeki tedaviler kapsam dışıdır. Ayrıca estetik ameliyatlar, diş tedavileri (özel kloz yoksa) ve poliçede belirtilen istisna durumlar da provizyon kapsamı dışında kalabilir.</p>
          </div>
        </div>

        <div class="faq-item">
          <button class="faq-question">
            Sigorta acentesi nedir? Neden acenteden sigorta yaptırmalıyım?
            <span class="faq-icon">+</span>
          </button>
          <div class="faq-answer">
            <p>Sigorta acentesi, sigorta şirketleri ile müşteriler arasında aracılık yapan yetkili kurumdur. Bağımsız bir acente olarak birden fazla sigorta şirketinden teklif alarak sizin için en uygun fiyat ve teminatı buluruz. Hasar durumunda da yanınızdayız.</p>
          </div>
        </div>

        <div class="faq-item">
          <button class="faq-question">
            Araç değer kaybı nedir ve nasıl talep edilir?
            <span class="faq-icon">+</span>
          </button>
          <div class="faq-answer">
            <p>Araç değer kaybı, kaza sonrası tamir edilse bile aracın ikinci el piyasa değerinin düşmesidir. Kazada %100 kusurlu değilseniz, kusurlu tarafın trafik sigortasından değer kaybı talep edebilirsiniz. Kaza tarihinden itibaren 2 yıl içinde başvuru yapılmalıdır.</p>
          </div>
        </div>

        <div class="faq-item">
          <button class="faq-question">
            Poliçem bitmeden yenileyebilir miyim?
            <span class="faq-icon">+</span>
          </button>
          <div class="faq-answer">
            <p>Evet, poliçenizi bitiş tarihinden önce yenileyebilirsiniz. Hatta biz müşterilerimizin poliçe bitiş tarihlerini takip ediyoruz ve 15 gün öncesinden hatırlatma yaparak kesintisiz koruma sağlıyoruz.</p>
          </div>
        </div>
      </div>

      <div class="cta-section" style="text-align: center; margin-top: 40px;">
        <p>Başka sorularınız mı var?</p>
        <a href="/bize-ulasin" class="btn-primary" style="margin-top: 15px; display: inline-block;">Bize Ulaşın</a>
      </div>
    </div>
  </section>
`;
